import SETTINGS from "../globals";

class ImgUtil {
  public static display_icon(
    icon_path: string | undefined,
    ifNoIcon: string = process.env.REACT_APP_PUBLIC_URL +
      "/resources/images/no-image.png"
  ): string | undefined {
    // for the icons comming from the server, we need to inject server root
    if (icon_path) {
      if (icon_path.substring(0, 4) !== "data:") {
        return SETTINGS.API_ROOT + "/" + icon_path;
      }
    }
    return icon_path ? icon_path : ifNoIcon;
  }

  public static display_static_image(name: string): string {
    return process.env.REACT_APP_PUBLIC_URL + "/resources/images/" + name;
  }
}

export default ImgUtil;
